import { useStaticQuery, graphql } from 'gatsby'

export const useHeroHomeQuery = () => {
  const { wp, wpPage } = useStaticQuery(graphql`
    query HeroHomeQuery {
      wpPage(title: { eq: "Home" }) {
        hero {
          hero {
            backgroundImageDesktop {
              sourceUrl
            }
            backgroundImageMobile {
              sourceUrl
            }
            backgroundImageDesktopPlaceholder
            backgroundImageMobilePlaceholder
            title
            text
          }
        }
      }
      wp {
        acfOptionsCommonItems {
          commonItems {
            topCallText
            topButtonText
            phoneNumber
          }
        }
      }
    }
  `)
  return { wp, wpPage }
}
